<template>
    <section class="container">
        <iv-card shadow>
            <h1 slot="title" class="siteName">{{siteName}}</h1>
            <iv-form ref="account" :model="user" label-position="left" :label-width="45" :rules="validation">
                <iv-form-item label="帐号" prop="username">
                    <input class="ivu-input" type="text" placeholder="帐号" v-model="user.username" @keyup.enter="login(user)" />
                </iv-form-item>
                <iv-form-item label="密码" prop="password">
                    <input class="ivu-input" type="password" placeholder="密码" v-model="user.password" @keyup.enter="login(user)" />
                </iv-form-item>
                <div>
                    <iv-button class="btn-full" :loading="loader.defaults" type="primary" @click="login(user)">登录</iv-button>
                </div>
            </iv-form>
        </iv-card>
        <LayoutFooter></LayoutFooter>
    </section>
</template>
<style>
    body{
        background-color: #eee;
    }
</style>
<style lang="scss" scoped>
    .siteName{
      font-size: 18px;
      text-shadow: 1px 2px 0 #ddd;
      color: #353535;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 8px;
    }
    .container{
        padding-top: 120px;
        width: 360px;
        margin: 0 auto;
        > footer{
          text-align: center;
          margin-top: 1em;
          color: #999;
        }
    }
    .ivu-form{
        background-color: #fff;
        box-sizing: border-box;
        position: relative;
        &:before{
            content: '';
            border: 15px solid transparent;
            border-left-width: 18px;
            border-right-width: 18px;
            border-bottom-color: #fff;
            top: -30px;
            left: 50%;
            margin-left: -18px;
            position: absolute;
        }
    }
    .remember{
        margin-bottom: 1em;
    }
    .btn-full{
        display: block;
        width: 100%;
        line-height: 29px;
        font-size: 16px;
    }
</style>
<script>
import LayoutFooter from "@/pages/commons/Footer";
  import { mapActions, mapMutations, mapGetters } from 'vuex';
  import {
    LOGIN,
    LOGOUT
  } from '../stores/types';
   import crypto from 'crypto';
export default {
    components:{
      LayoutFooter
    },
    data(){
        return {
            siteName: process.env.VUE_APP_SITE_NAME||"登录",
            user: {
                username: '',
                password: ''
            },
            remember: true,
            status: {
                loader: {
                    defaults: false
                }
            },
            validation: {
                username: [
                    // { type: 'email',  message: '邮箱账号不合法，请输入有效的邮箱账号重试', trigger: 'change' },
                    {
                        validator(rule, value, callback, source, options){
                            const errors = [];
                            if(typeof value === 'string'){
                                if(!value) errors.push(new Error('邮箱不能为空'));
                            }
                            callback(errors);
                        }
                    }
                ],
                password(rule, value, callback, source, options){
                    const errors = [];
                    if(typeof value === 'string'){
                        if(!value) errors.push(new Error('密码不能为空'));
                    }
                    callback(errors);
                }
            },
        }
    },
    watch: {
        'user.password'(){
            this.$refs.account.fields.find(item=>item.prop=='password').$emit('on-form-change');
        }
    },
    computed: {
        loader(){
            return this.status.loader;
        }
    },
    methods: {
      ...mapActions([LOGIN, LOGOUT]),
      $$loading(type="defaults"){
        this.loader[type] = true;
      },
      $$loaded(type="defaults"){
        this.loader[type] = false;
      },
      async login(account){
        if(!await this.$refs.account.validate()) return;
        this.$ivLoading.start();
        this.$$loading();
        try{
          await this[LOGIN]({userName: account.username, pwd: account.password}); //cc:login#0;login in ui function;
          this.$ivLoading.finish();
          this.$$loaded();
          const route = this.$route.query.redirect ? { path:this.$route.query.redirect } : {path:"/"}
          this.$router.replace(route);
        }catch(e){
          this.$$error(e);
          this.$ivLoading.error();
          this.$$loaded();
        }
        this.$ivLoading.finish();
      },
      async logout(){
        this.$ivLoading.start();
        this.$$loaded();
        try{
          await this[LOGOUT]();
        }catch(e){
          console.error(e);
        }
        this.$ivLoading.finish();
        this.$$loaded();
        this.$router.replace({name:'login'});
      }
    }
}
</script>
